export default __webpack_public_path__ + "static/media/Time_Zone_Dash.8d6c7d0f.svg";